(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["info-drawer-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-info-drawer-chat]')
      if (!trigger) return

      document.dispatchEvent(
        new CustomEvent('info-drawer:chat', {
          bubbles: true,
          detail: { trigger },
        })
      )

      // Hand the viewport over to the chat widget. Dispatched from the trigger,
      // not document, so it bubbles up to the app provider that owns dialog state.
      const dialog = trigger.closest('modal-dialog')
      if (dialog?.id) {
        trigger.dispatchEvent(
          new CustomEvent('modal-dialog::close', {
            bubbles: true,
            composed: true,
            detail: dialog.id,
          })
        )
      }

      if (typeof window.Kustomer?.open === 'function') {
        window.Kustomer.open()
      }
    },
    { passive: true }
  )
  } catch(e) { console.error(e); }
})();

})();
